import React from "react";
import { Modal, Button } from "antd";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { ok } from "assert";

const { confirm } = Modal;

function DeleteAppConfirm(props) {
  const showConfirm = e => {
    e.stopPropagation();
    confirm({
      title: props.title,
      content: props.content,
      onOk() {
        return new Promise((resolve, reject) => {
          props.onOk() ? resolve() : reject();
        }).catch(() => {});
      },
      okType: "danger",
      okText: props.delete,
      mask: false,
      maskClosable: true,
      autoFocusButton: ok
    });
  };
  return (
    <ActionButton type="link" onClick={e => showConfirm(e)}>
      <FormattedMessage id="manageApp_delete" />
    </ActionButton>
  );
}

export default DeleteAppConfirm;

const ActionButton = styled(Button)`
  padding: 0;
  font-size: 14px;
  line-height: 22px;
`;
